<template>
  <button class="close icon" @click="emit('close')" @keyup.space="(e) => e.preventDefault()">
    <svg version="1.1" viewBox="0 0 18 18" pointer-events="none">
      <path class="stroke stroke-broad" d="M9,8.4l3.5-3.5l0.6,0.6L9.6,9l3.5,3.5l-0.6,0.6L9,9.6l-3.5,3.5l-0.6-0.6L8.4,9L4.9,5.5l0.6-0.6L9,8.4z" />
    </svg>
  </button>
</template>
<script setup>
const emit = defineEmits(['close']);
</script>
<style scoped lang="scss">
.close {
  position: absolute;
  top: rem(8px);
  right: rem(8px);
  height: rem(18px);
  width: rem(18px);
  background: transparent;
  padding: 0;
  border: none;
  transform: scale(0);
  opacity: 0;
  transition: all 0.3s;

  @include triggered {
    transform: scale(1);
    opacity: 1;
    color: var(--c__accent);
  }
  svg {
    width: 100%;
  }
}

:hover > .close,
:focus > .close,
:hover ~ .close {
  transform: scale(1);
  opacity: 1;
}
</style>
